import { Component, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { OnDestroy } from "@angular/core/src/metadata/lifecycle_hooks";
import { ISubscription } from "rxjs/Subscription";
import { ChartPoint } from "../timeseries-chart/ChartPoint";
import { retry } from "rxjs/operator/retry";
import * as momentImported from 'moment'; const moment = momentImported;
import * as momentTZ_ from "moment-timezone"; const momentTZ=momentTZ_;
import * as Highcharts from 'highcharts';


import { ComponentInteractionService } from '../../entity-services/component-interaction.service';
import { AdminPortalAPIService } from '../../entity-services/admin-portal-api.service';
import { EntityConfigurationService } from "../../entity-services/features/entityConfiguration/entity-configuration.service";


@Component({
  selector: 'app-timeseries-chart',
  template: `  <div>
    <div class="showSpinner" *ngIf="isOperationInProgress">
        <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
    </div>
    <br/>
    <div class="form-group row">
        <label for="matricName" class="col-sm-2 col-form-label">Metrics</label>
        <div class="col-sm-4">
            <select class="form-control pull-left" title="Select Metric" [(ngModel)]="matricType" (change)="metricValueChange()">
                <option name="metrics" value="" selected>Select Metric</option>
                <option name="metrics" *ngFor="let mtc of metricList" [value]="mtc">{{mtc}}</option>
            </select>
        </div>
    </div>
    <br/>
    <div class="form-group row">
        <div class="col-sm-2 col-form-label"></div>
        <div class="col-sm-4">
            <mat-slider (input)="onSliderValueChange($event)" class="example-margin" [(ngModel)]="value" [tick-interval]="true" [max]="30"
                [min]="0" [step]="5">
            </mat-slider>
            <label>{{sliderValue}}</label>
        </div>
    </div>

    <div *ngIf="!isHidechartControl">
        <div *ngIf="!isChartNoData">
            <div [chart]="chart"></div>

        </div>
        <div *ngIf="isChartNoData">
            <img src="assets/NoDataChart.png" />
        </div>
    </div>`,
  styles: [``]
})
export class TimeseriesChartComponent implements OnInit, OnDestroy {

    timeseriesIdChange: ISubscription;
    timeseriesChartData: ChartPoint[];
    isOperationInProgress: boolean = false;
    isHidechartControl: boolean = false;
    metricList: string[];
    startDate: string;
    endDate: string;
    matricType: string = "";
    tickInterval: any = 900000;
    duration: any = "1W";
    timeseriesId: string;
    chart: Chart;
    isChartNoData: boolean = false;
    sliderValue: any = "1W";
    value: any = 20;
    errormessage: string;
    errorOccured: boolean;
    isTimesSeriesIDChange: boolean = false;
    
    
    constructor(private entityConfigurationService: EntityConfigurationService,private adminPortalAPIService: AdminPortalAPIService, private componentInteractionService: ComponentInteractionService) {
     
        
    }

    ngOnInit() {
        this.timeseriesIdChange = this.componentInteractionService.timeSeriedIdChangeForChartEvent.subscribe(
            timeseriesId => {
                this.timeseriesId = timeseriesId;
                this.isTimesSeriesIDChange = true;
                return this.getChart();
            });
    }

    ngOnDestroy() {
        if (this.timeseriesIdChange) {
            this.timeseriesIdChange.unsubscribe();
        }
    }

    onSliderValueChange(event: any) {
        switch (event.value) {
            case 0:
                this.sliderValue = "12h";
                break;
            case 5:
                this.sliderValue = "24h";
                break;
            case 10:
                this.sliderValue = "5D";
                break;
            case 15:
                this.sliderValue = "1W";
                break;
            case 20:
                this.sliderValue = "2W";
                break;
            case 25:
                this.sliderValue = "1M";
                break;
            case 30:
                this.sliderValue = "1Y";
                break;
        }
        this.getChart();
    }
    getMetricList() {
        
      
        this.entityConfigurationService.getForTimeSeries("/timeseries/samples/" + this.timeseriesId + "/metrics").subscribe(
            (data) => {
                this.metricList= data.map(d=>d.metric);
                console.log(this.metricList);
            }, error => this.handleError(error));
    }

    private handleError(error: any) {
        console.log("error occured:" + error);
        this.errorOccured = true;
        this.errormessage = error;
        this.isOperationInProgress = false;
    }

    formatTZDate_duration(timeFormat, duration, isStartDate) {
        var date;
        var formattedDate;

        if (isStartDate == 1) {
            var curr_date = moment().format('YYYY-MM-DD')
            date = moment.tz(curr_date).tz('UTC');
        } else if (isStartDate == 0) {
            date = momentTZ().utc();
        }

        if (duration != undefined) {
            date = date.subtract(1, duration);
        }

        if (timeFormat != undefined) {
            formattedDate = date.format(timeFormat);

        }

        return formattedDate;
    }

    //on Matric or duration change call the reload the chat
    metricValueChange() {
        this.getChart()
    }

    GetDuration(duration): void {
        var startTimeFormat = "YYYY-M-DDT00:00:00";
        var endTimeFormat = "YYYY-M-DDTHH:mm:ss";
        var chartTitleDateFormat = "MM/DD/YY";
        var timezone = momentTZ();
        var current_TimeZone = moment.tz.guess();
        if (duration == "12h") {
            this.startDate = moment.tz(current_TimeZone).subtract(12, 'hours').tz('UTC').format(endTimeFormat);
            this.endDate = moment.tz(current_TimeZone).tz('UTC').format(endTimeFormat);
        }
        else if (duration == "24h") {
            this.startDate = moment.tz(current_TimeZone).subtract(24, 'hours').tz('UTC').format(endTimeFormat);
            this.endDate = moment.tz(current_TimeZone).tz('UTC').format(endTimeFormat);
        }
        else if (duration == "5D") {
            this.startDate = moment.tz(current_TimeZone).subtract(5, 'day').tz('UTC').format(endTimeFormat);
            this.endDate = moment.tz(current_TimeZone).tz('UTC').format(endTimeFormat);

        }
        else if (duration === "1W") {
            this.startDate = this.formatTZDate_duration(endTimeFormat, "weeks", 1);
            this.endDate = this.formatTZDate_duration(endTimeFormat, undefined, 0);
        }
        else if (duration == "2W") {
            this.startDate = moment.tz(current_TimeZone).subtract(2, 'weeks').tz('UTC').format(endTimeFormat);
            this.endDate = moment.tz(current_TimeZone).tz('UTC').format(endTimeFormat);
        }
        else if (duration === "1M") {
            this.startDate = this.formatTZDate_duration(endTimeFormat, "months", 1);
            this.endDate = this.formatTZDate_duration(endTimeFormat, undefined, 0);
        }
        else if (duration === "1Y") {
            this.startDate = this.formatTZDate_duration(endTimeFormat, "years", 1);
            this.endDate = this.formatTZDate_duration(endTimeFormat, undefined, 0);
        }
    }

    setTickInterval() {
        switch (this.matricType) {
            case "AverageQuarterHour":
                this.tickInterval = 900000;
                break;

            case "AverageHourly":
                this.tickInterval = 3600000;
                break;

            default:
                this.tickInterval = undefined;
                // add point to chart series
                break;
        }
    }

    getChart() {
        if (this.timeseriesId == undefined || this.timeseriesId.length == 0) {
            this.isHidechartControl = true;
            this.metricList = [];
            return;
        }

        if (this.isTimesSeriesIDChange) {
            this.getMetricList();
            this.isTimesSeriesIDChange=false;
        }

        this.isHidechartControl = false;
        this.setTickInterval();
        this.GetDuration(this.sliderValue);

        this.isOperationInProgress = true;
        this.getTimeseriesData();
    }

    createChart() {
        this.chart = new Chart({
            chart: {
                type: 'line'
            },

            title: {
                text: 'Time Series Chart'
            },
            xAxis: {
                type: "datetime",

                dateTimeLabelFormats: {
                    day: "%e %b",
                    hour: "%H:%M",
                    minute: "%H:%M",
                    month: "%b %y",
                    second: "%H:%M",
                    week: "%e %b",
                    year: " %b %y"
                },
                tickInterval: this.tickInterval
            },
            credits: {
                enabled: false
            },
            lang: {
                noData: "No Data Available"
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030"
                }
            },
            series: [
                {
                name: 'Time',
                data: this.timeseriesChartData,

            }]
        });
        this.isOperationInProgress = false;
    }

    getTimeseriesData() {
        this.entityConfigurationService.getForTimeSeries("/timeseries/samples/" + this.timeseriesId + "?isglobal=true&starttime=" + this.startDate + "&endtime=" + this.endDate + "&orderby=timestamp asc&metric=" + this.matricType).subscribe(
            (data) => {
                let chartData = data;
                this.timeseriesChartData = chartData.map(function (d) {
                    return new ChartPoint(d.val, Date.parse(d.timestamp));
                })
                this.isChartNoData = chartData.length ? false : true;
                this.createChart();
            }
        );
    }
}

